import React, { act, useEffect, useState } from "react";
import { Button, Checkbox, Col, Collapse, Divider, Drawer, Form, Input, Row, Segmented, Select, Space, Tag, Tooltip } from "antd";
import { MinusCircleOutlined, DownOutlined, CheckSquareFilled, CloseOutlined, CloseSquareFilled, FilterOutlined } from '@ant-design/icons';
import { formatCount, pathToObject, objectToPath, ucfirst, handleTermSlash } from "../utils/Utils";
import DropMenu from "../util_components/DropMenu";
import { useHistory } from "react-router";
import FilterAutocomplete from "../util_components/FilterAutocomplete";
import conditional from "../utils/conditional";
import CollapseMenu from "../util_components/CollapseMenu";
import { useSession } from "../utils/Session";
import CopyISBNs from "./CopyISBNs";
import { apiCall } from "../utils/Api";
import MetaFilter from "./MetaFilters"

export default function BrowseFilters(props) {


    const { create = <></>, view = "", is_browse = false, multiple = true, context = { name: "", negated: false }, sort = <></>, filters = {}, setFilters = () => { }, searchFilters = {}, setSearchFilters = () => { }, listLabel = { key: "" }, path = "/browse", getBrowse = () => { }, setCurrent = () => { } } = props;
    const [vistoggle, setVistoggle] = useState("");
    const history = useHistory();
    const [metaSet, setMetaSet] = useState([]);
    const [show, setShow] = useState(false);
    const [session, setSession] = useSession();

    const linkOut = (_obj = searchFilters) => {
        if (changed) {
            history.push({ pathname: path + objectToPath({ ..._obj, "o": 0 }) });
        }
    }



    const toggleCategory = (_letter, _key, concat = false, action = "label", go = false) => {
        let _loc = pathToObject(history.location.pathname);
        let value = (searchFilters.hasOwnProperty(_letter)) ? [...searchFilters[_letter]] : []

        if (_key === "AND") {


            // don't toggle
            if (action === "exclude") {
                // remove
                value = [...searchFilters[_letter]].filter(item => item !== _key);
            } else {
                value.push(_key);
            }


            setSearchFilters({ ...searchFilters, [_letter]: value });
            return;
        }
        switch (action) {
            case "label":
                value = [_key]
                break;
            case "include":
                if (value.includes(_key)) {
                    // remove
                    value = [...searchFilters[_letter]].filter(item => item !== _key);
                } else {
                    value.push(_key);
                }
                break;
            case "exclude":
                if (value.includes("-" + _key)) {
                    // remove
                    value = [...searchFilters[_letter]].filter(item => item !== "-" + _key);
                } else {
                    value.push("-" + _key);
                }
                break;
            default:
                value = [_key]
                break
        }
        if (action === "label") {
            value = [_key]
        }
        setSearchFilters({ ...searchFilters, [_letter]: value });

        if (action === "label" || go) {
            setVistoggle("close");
            let _f = { ...searchFilters, [_letter]: value }
            if (_f.hasOwnProperty("o")) {
                delete _f.o;
            }
            if (_loc.hasOwnProperty("p")) {
                linkOut({ ..._f, "p": _loc.p });
                // history.push({ pathname: path + objectToPath({..._f, "p" : _loc.p}) })
            } else {
                linkOut(_f);
                // history.push({ pathname: path + objectToPath(_f) })
            }
        }
        return;
    }

    const getNameByKey = (_key, _letter) => {
        if (_key.substr(0, 1) === "-") {
            _key = _key.substr(1, _key.length);
        }
        let _fltr = filters.find(item => item.routing_char === _letter);
        if (_fltr && _fltr.hasOwnProperty("rows")) {
            let _cat = _fltr.rows.find(item => item.key === _key);
            if (_cat) {
                return _cat.name;
            } else {
                let ret = _key;
                _fltr.rows.forEach(itm => {
                    if (itm.hasOwnProperty("subfilter")) {
                        let _sub = itm.subfilter.find(item => item.key === _key);
                        if (_sub) {
                            ret = _sub.name;
                        }
                    }
                });
                return ret;
            }
        }
        return "";
    }

    const toggleSubjectsAndSubSubjects = (subject) => {
        let temp_search_filters = searchFilters;
        let subjects_remaining = [...searchFilters["c"]].filter(item => item !== subject);
        let sub_subjects_remaining = [];
        if (searchFilters["d"]) {
            [...searchFilters["d"]].filter(item => !item.includes(subject));
        }
        setVistoggle("close");
        if (temp_search_filters.hasOwnProperty("l")) {
            delete temp_search_filters.l;
        }
        if (temp_search_filters.hasOwnProperty("o")) {
            delete temp_search_filters.o;
        }
        temp_search_filters.c = subjects_remaining;
        temp_search_filters.d = sub_subjects_remaining;
        setSearchFilters(temp_search_filters);
        history.push({ pathname: path + objectToPath(temp_search_filters) })
    }

    const drawAllSelectedTags = () => {
        let count = 0;
        const ret = [];

        const buildTag = ({ key, item, index, onClick, onClose, label, color = "green" }) => (
            <Tag
                key={`${key}-${index}`}
                onClick={e => { e.preventDefault(); e.stopPropagation(); onClick(); }}
                onClose={e => { e.preventDefault(); e.stopPropagation(); onClose(); }}
                className="filterTag bcg2"
                style={{ color: "#888", marginRight: 5 }}
                color={color}
                closable
                closeIcon={<small><CloseOutlined style={{ fontSize: 7 }} /></small>}
            >
                <small>{label}</small>
            </Tag>
        );



        if (searchFilters.p) count++;

        Object.entries(searchFilters).forEach(([key, values], _index) => {
            if (!Array.isArray(values)) return;

            values.filter(i => i !== "AND").forEach((item, index) => {
                const label = getNameByKey(item, key);
                if (!label) return;
                count++;

                if (key === "c") {
                    ret.push(buildTag({
                        key: `${_index}-${index}`,
                        item,
                        index,
                        onClick: () => toggleSubjectsAndSubSubjects(item),
                        onClose: () => toggleSubjectsAndSubSubjects(item),
                        label,
                        color: item.startsWith("-") ? "red" : "green"
                    }));
                } else {
                    const val = item.startsWith("-") ? item.slice(1) : item;
                    const mode = item.startsWith("-") ? "exclude" : "include";
                    ret.push(buildTag({
                        key: `${_index}-${index}`,
                        item,
                        index,
                        onClick: () => toggleCategory(key, val, true, mode, true),
                        onClose: () => toggleCategory(key, val, true, mode, true),
                        label,
                        color: item.startsWith("-") ? "red" : "green"
                    }));
                }
            });
        });

        const pushKeywordTag = () => {
            if (searchFilters.k && searchFilters.k !== "keyword" && history.location.pathname.includes("/k/")) {
                const update = () => {
                    const updated = { ...searchFilters, k: "keyword" };
                    setSearchFilters(updated);
                    const loc = pathToObject(history.location.pathname);
                    history.push({ pathname: path + objectToPath(loc.p ? { ...updated, p: loc.p } : updated) });
                };
                ret.push(buildTag({
                    key: "keyword",
                    item: "keyword",
                    index: 0,
                    onClick: update,
                    onClose: update,
                    label: `Search Type: ${ucfirst(searchFilters.k)}`
                }));
            }
        };
        pushKeywordTag();

        if (searchFilters.t) {
            count++;
            const terms = handleTermSlash(searchFilters.t, false).split(" ");
            terms.forEach(term => {
                if (!term) return;
                const update = () => {
                    const filtered = terms.filter(t => t !== term).join(" ");
                    const updated = { ...searchFilters, o: 0, t: handleTermSlash(filtered, true) };
                    setSearchFilters(updated);
                    const loc = pathToObject(history.location.pathname);
                    history.push({ pathname: path + objectToPath(loc.p ? { ...updated, p: loc.p } : updated) });
                };
                ret.push(buildTag({
                    key: term,
                    item: term,
                    index: 0,
                    onClick: update,
                    onClose: update,
                    label: (listLabel.key === term) ? listLabel.value : term,
                    color: term.startsWith("-") ? "red" : "green"
                }));
            });
        }

        const pushSimpleTag = (key, label, extra = {}) => {
            if (searchFilters[key]) {
                count++;
                const updated = { ...searchFilters, [key]: "", ...extra };
                const update = () => {
                    setSearchFilters(updated);
                    const loc = pathToObject(history.location.pathname);
                    history.push({ pathname: path + objectToPath(loc.p ? { ...updated, p: loc.p } : updated) });
                };
                ret.push(buildTag({
                    key,
                    item: key,
                    index: 0,
                    onClick: update,
                    onClose: update,
                    label,
                    color: key === "x" && context.negated ? "red" : "green"
                }));
            }
        };

        pushSimpleTag("z", searchFilters.z);
        pushSimpleTag("x", context.name || searchFilters.x, { v: "" });

        ret.push(
            <Button
                key="clear"
                onClick={() => {
                    const reset = searchFilters.x
                        ? { v: searchFilters.v !== "sequence" ? searchFilters.v : "", o: 0 }
                        : pathToObject("/");
                    setSearchFilters(reset);
                    history.push({ pathname: path + objectToPath(reset), state: searchFilters.x ? undefined : `bm_reset${Math.random()}` });
                }}
                style={{ height: 22, marginTop: 1, lineHeight: "12px", marginRight: 6, padding: 0 }}
                type="link"
                size="small"
            >
                <em style={{ "fontSize": "12px" }}>← Clear filters</em>
            </Button>
        );

        return count > 0 ? (
            <div >

                <div style={{ minHeight: 26, maxHeight: 87, overflow: "auto" }}>
                    <Space>
                        <Space wrap size={[0, 5]}>{ret}</Space>
                    </Space>
                </div>
            </div>
        ) : <></>;
    };


    const drawSelectedTags = (_selected = [], _letter, _exclude = false) => {

        // console.log(searchFilters);
        if (searchFilters.hasOwnProperty(_letter)) {
            _selected = searchFilters[_letter];
        } else {
            _selected = [];
        }

        if (!Array.isArray(_selected)) {
            _selected = []
        }


        return (
            <Row align="top">
                <Col flex={"100%"} >
                    <div style={{ "marginTop": "-5px", "maxHeight": "10vh", "overflow": "auto" }}>
                        {_selected.filter(i => i !== "AND").map((item, index) => {
                            return (
                                <Tag key={index} onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggleCategory(_letter, (item.substr(0, 1) === "-") ? item.substr(1, item.length) : item, true, (item.substr(0, 1) === "-") ? "exclude" : "include"); }} color={(item.substr(0, 1) === "-") ? "red" : "green"} onClose={(e) => { e.preventDefault(); e.stopPropagation(); toggleCategory(_letter, (item.substr(0, 1) === "-") ? item.substr(1, item.length) : item, true, (item.substr(0, 1) === "-") ? "exclude" : "include"); }} style={{ "fontWeight": "normal", "padding": "0px 4px", "lineHeight": "12px", "color": "#888", "marginRight": "3px", "maxWidth": "212px", "overflow": "hidden", "textOverflow": "ellipsis" }} closeIcon={<small><CloseOutlined style={{ "fontSize": "7px" }} /></small>} closable>
                                    <small>{getNameByKey(item, _letter)}</small>
                                </Tag>
                            )
                        })}
                    </div>
                </Col>
            </Row>
        )
    }

    const drawFilter = (_filter, _mobile = false) => {
        const { rows = [] } = _filter;
        const tips = [];

        let _required = [];
        let _negated = [];
        let _metafilter = false;
        if (metaSet.length > 0 && _filter.meta_filters.length > 0) {
            metaSet.forEach(item => {
                if (item.hasOwnProperty("negate") && item.negate) {
                    _negated = _negated.concat(item.filters);
                } else {
                    _required = _required.concat(item.filters);
                }
            })
            _metafilter = true;
        }
        return rows.map((category, index) => {
            const { key = "", count = "", subfilter = [], name } = category;

            if (_metafilter) {
                if (_required.length > 0 && !_required.includes(key)) {
                    return (<></>);
                }
                if (_negated.length > 0 && _negated.includes(key)) {
                    return;
                }
            }

            if (key === "--") {
                return (
                    <div key={index} className="filter-divider-wrap">
                        <Divider className="filter-divider" plain>
                            <small className="filter-divider-text">{name.toUpperCase()}</small>
                        </Divider>
                    </div>
                );
            }

            let any_included = false;
            let any_excluded = false;

            if (searchFilters?.[_filter.routing_char]?.length > 0) {
                const first = searchFilters[_filter.routing_char][0];
                any_excluded = first.startsWith("-");
                any_included = !any_excluded;
            }

            const is_included = searchFilters?.[_filter.routing_char]?.includes(key) || false;
            const is_excluded = searchFilters?.[_filter.routing_char]?.includes("-" + key) || false;

            const renderControls = (itemKey, count, isIncl, isExcl) => (
                <div className="filter-controls">
                    <Space size={2}>
                        <div className={any_included ? "disabled" : ""}>
                            <CloseSquareFilled
                                style={{ fontSize: _mobile ? "20px" : "14px" }}
                                onClick={() =>
                                    any_included ? () => { } : toggleCategory(_filter.routing_char, itemKey, true, "exclude")
                                }
                                className={`filter-icon ${isExcl ? "filter-red" : "filter-gray"} ${count > 0 ? "" : "filter-disabled"
                                    }`}
                            />
                        </div>
                        <div className={any_excluded ? "disabled" : ""}>
                            <CheckSquareFilled
                                style={{ fontSize: _mobile ? "20px" : "14px" }}
                                onClick={() =>
                                    any_excluded ? () => { } : toggleCategory(_filter.routing_char, itemKey, true, "include")
                                }
                                className={`filter-icon ${isIncl ? "filter-blue" : "filter-gray"} ${count > 0 ? "" : "filter-disabled"
                                    }`}
                            />
                        </div>
                    </Space>
                </div>
            );

            return (
                <div
                    key={index}
                    className="filter-row"
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "0px",
                        marginBottom: "0px",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row-reverse",
                            gap: "10px",
                            justifyContent: "space-between",
                        }}
                    >
                        <div>{(multiple) ? renderControls(key, count, is_included, is_excluded) : <>&nbsp;</>}</div>
                        <div
                            className={`filter-label ${count > 0 ? "" : "filter-disabled"}`}
                            onClick={() => toggleCategory(_filter.routing_char, key, false, "label")}
                        >
                            <small>
                                <div style={{ marginRight: "10px" }} className="filter-count">
                                    {formatCount(count)}
                                </div>
                                <span style={{ fontSize: _mobile ? "16px" : "" }} className="c">
                                    <Tooltip mouseEnterDelay={0.5} title={tips[key] || name}>
                                        {is_included || is_excluded ? <strong>{name}</strong> : name}
                                    </Tooltip>
                                </span>
                            </small>
                        </div>
                    </div>

                    {subfilter.length > 0 && (
                        <div className="subfilters-wrap" style={{ display: "flex", flexDirection: "column", marginLeft: "0px", gap: "0px" }}>
                            {subfilter.map((item, idx) => {
                                const isIncl = searchFilters?.[_filter.routing_char]?.includes(item.key) || false;
                                const isExcl = searchFilters?.[_filter.routing_char]?.includes("-" + item.key) || false;

                                return (
                                    <div key={idx} style={{ display: "flex", flexDirection: "row-reverse", justifyContent: "space-between" }}>
                                        {renderControls(item.key, item.count, isIncl, isExcl)}
                                        <Tooltip
                                            mouseEnterDelay={0.5}
                                            title={
                                                <small>
                                                    {item.name}
                                                    <span className="filter-count">{formatCount(item.count)}</span>
                                                </small>
                                            }
                                        >
                                            <div
                                                className={`filter-label filter-sub ${item.count > 0 ? "" : "filter-disabled"}`}
                                                onClick={() => toggleCategory(_filter.routing_char, item.key, false, "label")}
                                            >
                                                <small>
                                                    <div className="filter-count">{formatCount(item.count)}</div>
                                                    <span className="c">
                                                        - {isIncl || isExcl ? <strong>{item.name}</strong> : item.name}
                                                    </span>
                                                </small>
                                            </div>
                                        </Tooltip>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            );
        });
    };


    const resetFilter = (_key) => {
        setVistoggle("close");
        setSearchFilters({ ...searchFilters, [_key]: [] });
    }

    const changed = decodeURI(objectToPath(searchFilters).replace("/filter", "")) !== history.location.pathname.replace(path, "").replace("/filter", "");

    const go = () => {
        if (changed) {

            if (searchFilters.hasOwnProperty("o")) {
                delete searchFilters.o;
            }
            let _loc = pathToObject(history.location.pathname);
            if (_loc.hasOwnProperty("p")) {
                history.push({ pathname: path + objectToPath({ ...searchFilters, "p": _loc.p, "o": 0 }, true) });
            } else {
                history.push({ pathname: path + objectToPath({ ...searchFilters, "o": 0 }, true) });
            }
            setVistoggle("close");
        }
    }


    const drawHeader = (_filter = {}, _mobile = false) => {

        const {
            exclude = false,
            title = "",
            routing_char = "r",
            selected_rows = [],
            rows = [],
        } = _filter;

        return (<>
            <div className="float-flex" style={{ "gap": "10px" }}>
                <div><nobr className="c" style={{ "fontWeight": "600" }}>{(!_mobile) ? title : ""}</nobr></div>
                <div>

                    <Space size={3}>

                        <Segmented value={(searchFilters.hasOwnProperty(routing_char) && searchFilters[routing_char].includes("AND")) ? "include" : "exclude"} disabled={!(searchFilters.hasOwnProperty(routing_char) && searchFilters[routing_char].length > 1)} onClick={(e) => {

                            e.preventDefault();
                            e.stopPropagation();
                            if (searchFilters.hasOwnProperty(routing_char) && searchFilters[routing_char].includes("AND")) {
                                toggleCategory(routing_char, "AND", false, "exclude")
                            } else {
                                toggleCategory(routing_char, "AND", false, "include")
                            }

                        }} className="tiny-segment" size="small" options={[
                            {
                                value: 'include',
                                label: <small>All</small>

                            },
                            {
                                value: 'exclude',
                                label: <small>Any</small>
                            }
                        ]}
                        />

                        {(!_mobile &&

                            <Col flex={"25px"}>
                                <Button style={{ "padding": "0px 7px", "marginTop": "0px" }} onClick={() => go()} disabled={(!changed)} type="primary" className={(_mobile) ? "" : "tiny-btn"}><small>Go!</small></Button>
                            </Col>
                        )}


                        <Button style={{ "marginTop": "0px" }} onClick={() => resetFilter(routing_char)} disabled={!(searchFilters.hasOwnProperty(routing_char) && searchFilters[routing_char].length > 0)} size="small" className="tiny-btn" type="danger"><small>Reset</small></Button>

                    </Space>
                </div>
            </div>


            <conditional.true value={(_filter.name !== "all")}>
                <FilterAutocomplete mobile={_mobile} searchFilters={searchFilters} name={_filter.name} filters={filters} setFilters={setFilters} />
            </conditional.true>
            {/* <Divider dashed style={{ "margin": "10px 0px" }} /> */}


            <conditional.true value={(searchFilters.hasOwnProperty(routing_char) && searchFilters[routing_char].length > 0)}>
                <div className="shim" /><div className="shim" />
                {drawSelectedTags(selected_rows, routing_char, exclude)}
                <Divider dashed style={{ "margin": "8px 0px", "marginTop": "0px" }} />
            </conditional.true>
        </>
        )
    }

    const drawFilters = (_filter, _index) => {

        const align_left = (_filter?.name === "language")

        return (
            <DropMenu alignLeft={align_left} block={true} vistoggle={vistoggle} setVistoggle={setVistoggle} onClose={() => linkOut({ ...searchFilters })} key={_index}
                label={<>{(multiple) ? drawHeader(_filter) : <><div className="float-flex"><strong>{_filter.title}</strong> <Button onClick={() => resetFilter(_filter.routing_char)} style={{ "marginTop": "0px" }} size="small" className="tiny-btn" type="danger"><small>Reset</small></Button></div><Divider style={{ "margin": "5px 0px" }} dashed />
                    <conditional.true value={(_filter.has_autocomplete)}>
                        <FilterAutocomplete mobile={false} searchFilters={searchFilters} name={_filter.name} filters={filters} setFilters={setFilters} />
                        <div className="shim" />
                    </conditional.true>
                </>}<MetaFilter metaSet={metaSet} setMetaSet={setMetaSet} filter={_filter} /> </>}
                count={_filter.rows.length}
                active={(_filter.selected_rows.filter(item => item !== "AND").length)}
                title={_filter.title}>
                <div style={{ "width": "100%", "maxHeight": "25vh", "overflow": "auto" }} >
                    {drawFilter(_filter)}
                </div>
            </DropMenu>

        )
    }

    const drawMobileFilters = (_filter, _index) => {


        //  return (
        //     <CollapseMenu  key={_index}
        //         label={<>{drawHeader(_filter)}</>}
        //         index={_index}
        //         count={_filter.rows.length}
        //         active={(_filter.selected_rows.filter(item => item !== "AND").length)}
        //         title={_filter.title}>
        //         <div style={{ "width": "100%", "maxHeight": "25vh", "overflow": "auto" }} >
        //             {drawFilter(_filter)}
        //         </div>
        //     </CollapseMenu>

        // )

        return (
            <Collapse.Panel header={_filter?.title} key={_index}>
                <div>
                    {drawHeader(_filter, true)}
                    <div className="shim" />
                    {drawFilter(_filter, true)}
                </div>
            </Collapse.Panel>
        )
    }


    const SearchWithin = () => {


        const [val, setVal] = useState((searchFilters.hasOwnProperty("t") ? searchFilters.t : ""));


        return (

            <Input.Search allowClear value={(props?.loading) ? "" : val} onChange={(e) => setVal(e.target.value)} onSearch={(e, f) => {
                setVal(e);
                e = handleTermSlash(e, true)
                if ((session.has_bm_data_full || session.has_bm_data_lite)) {
                    history.push({ pathname: path + objectToPath({ ...filters, "t": e, "o": 0 }) });
                } else {
                    history.push({ pathname: path + objectToPath({ ...filters, "v": "date", "t": e, "o": 0 }) });
                }
            }} enterButton placeholder="Search within..." />



        )


    }

    const setSupplier = (_supplier) => {
        apiCall("session/setSupplier", { supplier: _supplier }, (_status, _result) => {
            if (_status) {
                setSession(_result);
                getBrowse();
            }
        })
    }

    return (
        <>
            <Divider style={{ "margin": "5px 0px", "marginBottom": "10px" }} dashed />

            <div className="hide">
                <div style={{ "display": "flex", "gap": "5px" }}>
                    {Object.keys(filters).map(key => {
                        return drawFilters(filters[key])
                    })}
                </div>
                <Drawer className="filters-drawer" title="Filters" placement="left" onClose={() => { setShow(false); linkOut(searchFilters); }} open={show}>
                    <Collapse className="filter-collapse" ghost accordion defaultActiveKey={0} >
                        {Object.keys(filters).map(key => {
                            return drawMobileFilters(filters[key], key)
                        })}
                    </Collapse>
                </Drawer>
            </div>
            <div className="shim" /><div className="shim" />
            <Button onClick={() => setShow(true)} className="show" style={{ "marginBottom": "10px" }} block type="primary"><small><FilterOutlined /> Filters</small></Button>
            <div style={{ "alignItems": "flex-start" }} className="float-flex">
                <div>
                    <Space wrap>
                        <SearchWithin />
                        {create}

                        {(is_browse && view==="list" && (session.has_bm_data_lite || session.has_bm_data_full)) &&
                            <Form.Item noStyle label={<small>Pubstock</small>}>
                                <Tooltip title={"Choose a supplier to add their availability to the list of titles below"}>
                                    <Select placeholder="Pubstock..." showSearch size="large" onChange={(e) => setSupplier(e)} value={session.chosen_supplier} style={{ width: 150 }}>
                                        <Select.Option value=""><small style={{ "color": "#bbb" }}>Pubstock...</small></Select.Option>
                                        {session?.suppliers?.map(item => {
                                            return <Select.Option key={item} value={item}><small>{item}</small></Select.Option>
                                        })}
                                    </Select>
                                </Tooltip>
                            </Form.Item>
                        }




                        {((is_browse && (session.has_bm_data_lite || session.has_bm_data_full)) &&
                            <Form.Item noStyle label={<small>ISBNs</small>}>
                                <CopyISBNs searchFilters={searchFilters} />
                            </Form.Item>
                        )}


                    </Space>
                </div>
                {sort}
            </div>
            <div className="shim" /><div className="shim" />
            <Space size={0} align="start" >
                {drawAllSelectedTags()}
            </Space>

            <div className="shim" />
            {/* <pre>{JSON.stringify(searchFilters, null, 2)}</pre> */}
        </>
    )
}